export class GetMetars {
  static readonly type = '[METARS] Get Metars Api';
}

export class SetLoading {
  static readonly type = '[METARS] Set Metars Loading Status';
  constructor(public payload: boolean) {}
}
